import "./TablaHorasLoading.css"

export default function TablaHorasLoading() {
  return <section className="tablaHorasLoading" />
}